import React from 'react';
import { Card } from './ui/card';
import { Check, X } from 'lucide-react';

const PricingSection = () => {
  const cooperItems = [
    "Competitive daily, weekly, and monthly rental rates",
    "Low delivery and pickup fees",
    "12.5% damage waiver",
    "No cleaning fees",
    "No environmental fees",
    "No processing fees",
    "No sales tax added to rental charges",
    "Clear pricing before you order",
  ];

  const otherCompanies = [
    { included: true, text: "Competitive rental rates advertised" },
    { included: false, text: "Higher delivery and pickup fees" },
    { included: false, text: "15%–20% damage waiver" },
    { included: false, text: "Cleaning fees" },
    { included: false, text: "Environmental fees" },
    { included: false, text: "Processing fees" },
    { included: false, text: "Sales tax added to rental charges" },
    { included: false, text: "Additional fees added later" },
  ];

  return (
    <section id="pricing" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Transparent Pricing You Can Trust
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            No surprises. No hidden fees. Just honest, competitive pricing that includes everything.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <Card className="p-8 border-2 border-orange-600 shadow-xl relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-orange-600 text-white px-4 py-1 text-sm font-semibold">
              Best Value
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Cooper Equipment Rentals</h3>
            <div className="space-y-3 mb-6">
              {cooperItems.map((item, idx) => (
                <div key={idx} className="flex items-start text-green-600">
                  <Check className="w-5 h-5 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-orange-50 p-4 rounded-lg">
              <p className="text-sm text-gray-700">
                <strong>Scissor Lift Delivery &amp; Pickup:</strong> $80 each way
              </p>
              <p className="text-sm text-gray-700 mt-2">
                <strong>Boom Lift Delivery &amp; Pickup:</strong> $95 each way
              </p>
            </div>
          </Card>

          <Card className="p-8 border-2 border-gray-300 shadow-lg opacity-90">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Other Rental Companies</h3>
            <div className="space-y-3 mb-6">
              {otherCompanies.map((item, idx) => (
                <div
                  key={idx}
                  className={`flex items-start ${item.included ? 'text-gray-400' : 'text-red-500'}`}
                >
                  {item.included ? (
                    <Check className="w-5 h-5 mr-3 flex-shrink-0 mt-0.5" />
                  ) : (
                    <X className="w-5 h-5 mr-3 flex-shrink-0 mt-0.5" />
                  )}
                  <span className="text-gray-700">{item.text}</span>
                </div>
              ))}
            </div>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-sm text-gray-600">
                <strong>Typical delivery fee:</strong> $120–$300 each way
              </p>
            </div>
          </Card>
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Our Pricing Promise</h3>
          <p className="text-lg text-gray-200 max-w-3xl mx-auto mb-6">
            The price we quote is the price you pay. Every quote includes equipment use, our standard 12.5%
            damage waiver, and clear delivery and pickup fees. No environmental, processing, or cleaning fees —
            and no surprises on the final invoice.
          </p>
          <div className="inline-flex items-center bg-orange-600 px-6 py-3 rounded-lg">
            <Check className="w-6 h-6 mr-2" />
            <span className="font-semibold">100% Transparent Pricing Guaranteed</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
